import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "book-hero" }
const _hoisted_2 = { class: "book-hero__card" }
const _hoisted_3 = { class: "book-hero__text" }
const _hoisted_4 = { class: "book-hero__category" }
const _hoisted_5 = { class: "book-hero__name" }
const _hoisted_6 = {
  key: 0,
  class: "book-hero__highlights"
}
const _hoisted_7 = { class: "book-hero__highlights-link" }
const _hoisted_8 = { class: "book-hero__highlights-link" }
const _hoisted_9 = {
  key: 0,
  class: "book-hero__highlights-link"
}

import type { DocView } from '@/models/doc'

import BookCover from '@/app/components/book/card/BookCover.vue'
import { computed } from 'vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'Hero',
  props: {
    doc: {},
    title: {},
    showHighlightsInfo: { type: Boolean, default: true }
  },
  setup(__props: any) {

const props = __props

const highlights = computed(() => {
  return props.doc.highlights.filter((h) => h.highlight_type !== 'bookmark')
})

const bookmarks = computed(() => {
  return props.doc.highlights.filter((h) => h.highlight_type === 'bookmark')
})

function getsCountText(count: number, text: string): string {
  switch (count) {
    case 0:
      return `No ${text}s`
    case 1:
      return `1 ${text}`
  }
  return `${count} ${text}s`
}

const highlightsCount = computed(() => {
  return getsCountText(highlights.value.length, 'Highlight')
})

const notesCount = computed(() => {
  return getsCountText(highlights.value.filter((h) => h.text).length, 'Note')
})

const bookmarksCount = computed(() => {
  return getsCountText(bookmarks.value.length, 'Bookmark')
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(BookCover, { doc: __props.doc }, null, 8, ["doc"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("h2", _hoisted_4, _toDisplayString(__props.title), 1),
      _createElementVNode("h1", _hoisted_5, _toDisplayString(__props.doc.title), 1),
      (__props.showHighlightsInfo)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createElementVNode("span", _hoisted_7, [
              _cache[0] || (_cache[0] = _createElementVNode("span", { class: "book-hero__highlights-icon iconfont ihighlights" }, null, -1)),
              _createTextVNode(_toDisplayString(highlightsCount.value), 1)
            ]),
            _createElementVNode("span", _hoisted_8, [
              _cache[1] || (_cache[1] = _createElementVNode("span", { class: "book-hero__highlights-icon iconfont inotes" }, null, -1)),
              _createTextVNode(_toDisplayString(notesCount.value), 1)
            ]),
            (bookmarks.value.length > 0)
              ? (_openBlock(), _createElementBlock("span", _hoisted_9, [
                  _cache[2] || (_cache[2] = _createElementVNode("span", { class: "book-hero__highlights-icon iconfont iflag" }, null, -1)),
                  _createTextVNode(_toDisplayString(bookmarksCount.value), 1)
                ]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})